module.exports = __webpack_public_path__ + "assets/phoenix-sales-recruiting-process-4.01df7d71.png";